import TeaserController from './Controller/TeaserController';
